import { createContext, useContext } from 'react';

export type AcademicDisciplineContextType = {
  academicDisciplineNameLoading: boolean;
  academicDisciplineName?: string;
};

const AcademicDisciplineContext = createContext<AcademicDisciplineContextType>({
  academicDisciplineNameLoading: false,
  academicDisciplineName: undefined,
});

export const useAcademicDisciplineName = () => useContext(AcademicDisciplineContext);

export default AcademicDisciplineContext;
